import { useCallback, useRef, useEffect } from 'react';
export function useHoldToRepeat({ onAction, disabled = false }) {
    const intervalRef = useRef(null);
    const holdRepeatMs = 150;
    const stopHold = useCallback(() => {
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    const startHold = useCallback(() => {
        if (disabled) {
            return;
        }
        onAction();
        intervalRef.current = setInterval(() => {
            onAction();
        }, holdRepeatMs);
    }, [disabled, onAction, holdRepeatMs]);
    // Cleanup on unmount
    useEffect(() => stopHold, [stopHold]);
    useEffect(() => {
        if (disabled) {
            stopHold();
        }
    }, [disabled, stopHold]);
    return {
        startHold,
        stopHold
    };
}
